/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 316:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(252);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(210);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(193);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(317);
/* harmony import */ var core_js_modules_es_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_last_index_of_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(250);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(205);
/* harmony import */ var core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search_js__WEBPACK_IMPORTED_MODULE_7__);








!function (f) {
  var t = "collapser",
      a = {
    mode: "words",
    speed: "slow",
    truncate: 10,
    ellipsis: " ... ",
    controlBtn: null,
    showText: "Read More",
    hideText: "Read Less",
    showClass: "show-class",
    hideClass: "hide-class",
    atStart: "hide",
    blockTarget: "next",
    blockEffect: "fade",
    lockHide: !1,
    changeText: !1,
    beforeShow: null,
    afterShow: null,
    beforeHide: null,
    afterHide: null
  };

  function o(e, t) {
    var o = this;
    o.o = f.extend({}, a, t), o.e = f(e), o.init();
  }

  o.prototype = {
    init: function init() {
      var e = this;
      e.mode = e.o.mode, e.remaining = null, e.ctrlButton = f.isFunction(e.o.controlBtn) ? e.o.controlBtn.call(e.e) : f('<a href="#" data-ctrl></a>'), "lines" == e.mode && e.e.wrapInner("<div>");
      var t = f.isFunction(e.o.atStart) ? e.o.atStart.call(e.e) : e.o.atStart;
      "hide" == (t = void 0 !== e.e.attr("data-start") ? e.e.attr("data-start") : t) ? e.hide(0) : e.show(0);
    },
    show: function show(e) {
      var t = this,
          o = t.e;
      t.collapsed = !1, void 0 === e && (e = t.o.speed), f.isFunction(t.o.beforeShow) && t.o.beforeShow.call(t.e, t);

      function a() {
        f.isFunction(t.o.afterShow) && t.o.afterShow.call(t.e, t);
      }

      if (o.find("[data-ctrl]").remove(), "block" == t.mode) t.blockMode(o, "show", e, a);else {
        var n = "lines" == t.mode ? o.children("div") : o,
            i = n.height();
        if ("lines" == t.mode) n.height("auto");else {
          var l = n.data("collHTML");
          void 0 !== l && n.html(l);
        }
        var s = n.height();
        n.height(i), n.animate({
          height: s
        }, e, function () {
          n.height("auto"), a();
        }), o.removeClass(t.o.hideClass).addClass(t.o.showClass), f.isFunction(t.o.controlBtn) || o.append(t.ctrlButton), t.ctrlButton.html(t.o.hideText);
      }
      t.bindEvent(), t.o.lockHide && t.ctrlButton.remove();
    },
    hide: function hide(e) {
      var t = this,
          o = t.e;
      t.collapsed = !0, void 0 === e && (e = t.o.speed), f.isFunction(t.o.beforeHide) && t.o.beforeHide.call(t.e, t);

      function a() {
        f.isFunction(t.o.afterHide) && t.o.afterHide.call(t.e, t);
      }

      if (o.find("[data-ctrl]").remove(), "chars" == t.mode || "words" == t.mode) {
        var n = o.html(),
            i = t.getCollapsedHTML(n, t.mode, t.o.truncate);

        if (i) {
          var l = o.text();
          t.remaining = l.split("words" == t.mode ? " " : "").length - t.o.truncate, o.data("collHTML", n), o.html(i);
        } else t.remaining = 0;
      }

      if ("lines" == t.mode) {
        var s = o.children("div"),
            r = s.outerHeight();

        if (0 == (c = s.find("[data-col-char]")).length) {
          var c = f('<span style="display:none" data-col-char>.</span>');
          s.prepend(c);
        }

        var d = c.height(),
            h = d * t.o.truncate + d / 4;
        r <= h ? (h = "auto", t.remaining = 0) : t.remaining = parseInt(Math.ceil((r - h) / d)), s.css({
          overflow: "hidden",
          height: h
        });
      }

      "block" == t.mode && t.blockMode(o, "hide", e, a), a(), "block" != t.mode && (o.removeClass(t.o.showClass).addClass(t.o.hideClass), !f.isFunction(t.o.controlBtn) && 0 < t.remaining && o.append(t.ctrlButton), t.ctrlButton.html(t.o.showText)), t.bindEvent();
    },
    blockMode: function blockMode(e, t, o, a) {
      var n = this,
          i = ["fadeOut", "slideUp", "fadeIn", "slideDown"],
          l = "fade" == n.o.blockEffect ? 0 : 1,
          s = "hide" == t ? i[l] : i[2 + l];
      f.isFunction(n.o.blockTarget) ? n.o.blockTarget.call(n.e)[s](o, a) : f.fn[n.o.blockTarget] && f(e)[n.o.blockTarget]()[s](o, a), "show" == t ? (e.removeClass(n.o.showClass).addClass(n.o.hideClass), n.o.changeText && e.text(n.o.hideText)) : (e.removeClass(n.o.hideClass).addClass(n.o.showClass), n.o.changeText && e.text(n.o.showText));
    },
    getCollapsedHTML: function getCollapsedHTML(e, t, o) {
      for (var a = !1, n = 0, i = 0, l = !0, s = 0; s <= e.length; s++) {
        if (char = e.charAt(s), "<" == char && (a = !0), ">" == char && (a = !1), n == o) {
          i = s, l = !1;
          break;
        }

        a || ("words" == t && " " == char && n++, "chars" == t && n++);
      }

      if (l) return !1;
      var r = e.slice(0, i);
      return this.balanceTags(r) + '<span class="coll-ellipsis">' + this.o.ellipsis + "</span>";
    },
    balanceTags: function balanceTags(e) {
      e.lastIndexOf("<") > e.lastIndexOf(">") && (e = e.substring(0, e.lastIndexOf("<")));
      var t = e.match(/<[^>]+>/g),
          o = new Array();

      for (tag in t) {
        t[tag].search("/") <= 0 ? o.push(t[tag]) : 1 == t[tag].search("/") && o.pop();
      }

      for (; 0 < o.length;) {
        var a = o.pop();
        e += "</" + (a = a.substring(1, a.search(/[>]/))) + ">";
      }

      return e;
    },
    bindEvent: function bindEvent() {
      var t = this;
      ("block" == t.mode ? t.e : t.ctrlButton).off("click").on("click", function (e) {
        e.preventDefault(), t.collapsed ? t.show() : t.hide();
      });
    }
  }, f.fn[t] = function (e) {
    return this.each(function () {
      f.data(this, t) || f.data(this, t, new o(this, e));
    });
  };
}(jQuery, (window, document));

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			1: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbibendum"] = self["webpackChunkbibendum"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [37], () => (__webpack_require__(316)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;